import { render, staticRenderFns } from "./applicationList.vue?vue&type=template&id=48f3d3e6&scoped=true"
import script from "./applicationList.vue?vue&type=script&lang=js"
export * from "./applicationList.vue?vue&type=script&lang=js"
import style0 from "./applicationList.vue?vue&type=style&index=0&id=48f3d3e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3d3e6",
  null
  
)

export default component.exports